module.exports = __webpack_public_path__ + "img/wp-new-habit-card21.ba1aba7e.jpg";